import React, { useContext, useEffect, useState } from "react";
import Select from "react-dropdown-select";
import { API } from "../../../../config/api";
import swal from "sweetalert";
import LoaderHome from "../../../Loader/LoaderHome";
import { SettingGeneralContext } from "../../../../context/settingGeneralContext";
import SearchableTreatmentDropdown from "./Other/SearchableTreatmentDropdown";

function TreatmentDropdownContent({
  selectKey,
  handleInputChange2,
  getDataTreatment,
  page,
  limit,
  ascending,
  keyword,
}) {
  const context = useContext(SettingGeneralContext);
  const token = localStorage.getItem("token");

  const [getData, setGetData] = useState([]);
  const [getDataTreatmentByCategory, setGetDataTreatmentByCategory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedTreatment, setSelectedTreatment] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [searchTreatment, setSearchTreatment] = useState("");
  const fetchParams = {
    headers: { Authorization: `${token}`, "Content-Type": "application/json" },
  };

  const GetResponseDataTreatmentCategory = async () => {
    try {
      setLoading(true);
      const response = await API.get(
        `transaction-service/treatment-categories?page=${page}&limit=${limit}&ascending=${ascending}&search=${keyword}`,
        fetchParams
      );
      if (response?.status === 200) {
        setGetData(response.data.data);
      }
    } catch (error) {
      swal({
        title: "Failed",
        text: `${error.response?.data?.message || error.message}`,
        icon: "error",
        timer: 3000,
        buttons: false,
      });
    } finally {
      setLoading(false);
    }
  };

  const GetResponseDataTreatmentByCategory = async (treatmentId, search = "") => {
    try {
      setLoading(true);
      const response = await API.get(
        `transaction-service/treatment-categories/by/${treatmentId}?page=0&limit=10&search=${search}`,
        fetchParams
      );
      if (response?.status === 200) {
        setGetDataTreatmentByCategory(response.data.data.treatments);
      }
    } catch (error) {
      swal({
        title: "Failed",
        text: `${error.response?.data?.message || error.message}`,
        icon: "error",
        timer: 3000,
        buttons: false,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    GetResponseDataTreatmentCategory();
  }, []);

  return (
    <>
      {loading && <LoaderHome />}

      <div
        style={{
          flex: "25%",
          display: "flex",
          alignItems: "center",
          marginRight: "10px",
        }}
      >
        <div style={{ width: "100%" }}>
          <div style={{ fontSize: "12px", fontWeight: "bold" }}>Kategori Treatment</div>

          <select
            className="form-select"
            aria-label="Pilih Kategori Treatment"
            name="id_treatment_category"
            value={selectedCategory || ""} // gunakan ID kategori
            onChange={(e) => {
              const categoryId = e.target.value;
              setSelectedCategory(categoryId);
              setGetDataTreatmentByCategory([]);
              setSelectedTreatment("");
              setSearchTreatment("");
              if (categoryId) {
                GetResponseDataTreatmentByCategory(categoryId, "");
              }
            }}
            style={{
              cursor: "pointer",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            <option value="">Pilih Kategori Treatment</option>
            {getData.map((item, index) => (
              <option
                key={index}
                value={String(item.id)} // pastikan string untuk konsistensi
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {item.name}
              </option>
            ))}
          </select>
        </div>
      </div>

      {selectedCategory && (
        <div
          style={{
            flex: "40%",
            display: "flex",
            flexDirection: "column",
            marginRight: "10px",
          }}
        >
          <label style={{ fontSize: "12px", fontWeight: "bold", marginBottom: "4px" }}>
            Treatment
          </label>

          <SearchableTreatmentDropdown
            name="id_treatment"
            getDataTreatmentByCategory={getDataTreatmentByCategory}
            selectedTreatmentId={selectedTreatment}
            setSelectedTreatmentId={setSelectedTreatment}
            handleInputChange2={handleInputChange2}
            searchTerm={searchTreatment}
            setSearchTerm={setSearchTreatment}
            onSearch={() => GetResponseDataTreatmentByCategory(selectedCategory, searchTreatment)}
          />
        </div>
      )}

    </>
  );
}

export default TreatmentDropdownContent;
